import { Button, Space } from "antd";
import Search from "antd/es/input/Search";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ClientFDBService from "../../../services/ClientFDBService";
import ProductService from "../../../services/ProductService";

const FdbLookup = ({
  user,
  onAdd,
  dosageFormList,
  isNew,
  packageId,
  currentProduct,
}) => {
  const { t } = useTranslation("fdbLookup");

  const [error, setError] = useState("");
  const [fdbPackagedDrug, setFdbPackagedDrug] = useState(null);
  const currentPricesRef = useRef(null);

  const onSearch = async (value, _e, _info) => {
    setError("");
    try {
      const data = await ClientFDBService.getFdbPackagedDrugByNdc(user, value);
      const { images, ...rest } = data.fdbPackagedDrug;
      const fields = Object.values(rest);
      const allEmpty = fields.every(
        (value) => value === null || value === undefined || value === "",
      );
      if (data && !allEmpty) {
        const fdbPackagedDrug = data.fdbPackagedDrug;
        const product = await ProductService.getProductByPackageId(
          user,
          fdbPackagedDrug.packagedDrugID,
        );
        if (product && isNew) {
          setError(t("errorExists"));
        } else {
          setFdbPackagedDrug(fdbPackagedDrug);
          currentPricesRef.current = data.currentPrices;
        }
      } else {
        setError(t("errorNotFound"));
      }
    } catch (error) {
      setError(error);
    }
  };

  const getCurrentPrice = (code) => {
    const item = currentPricesRef.current?.items?.find(
      (x) => x.priceTypeCode === code,
    );
    if (item) {
      const price = item.price.toFixed(2);
      const result = parseFloat(price);
      return result;
    }

    return null;
  };

  const convert = () => {
    const o = { ...fdbPackagedDrug };
    let dosageForm;
    const doseFormDesc = o?.doseFormDesc?.toUpperCase();
    if (doseFormDesc) {
      dosageForm = dosageFormList.find((d) => d.type === doseFormDesc);
    }
    if (!dosageForm) {
      dosageForm = { id: Number(o.doseFormID), type: doseFormDesc };
      dosageFormList.push(dosageForm);
    }
    let tallManName = o.drugNameTallmanDesc;
    if (o.drugNameDesc === tallManName) {
      tallManName = "";
    }
    const product = {
      images: isNew ? [] : currentProduct?.images || [],
      isEnabled: true,
      isPending: false,
      productId: o.packagedDrugID.substring(0, 9),
      packageId: o.packagedDrugID,
      humanReadableId: o.ndcFormatted,
      primaryName: o.drugNameDesc?.toUpperCase(),
      tallManName: tallManName,
      manufacturer: {
        fullName: o.labelerName,
        abbrName: o.labelerName,
      },
      therapeuticEquivalencyCode: o.dispensableGenericID,
      packageDescription: o.packageDesc,
      packageQuantity: o.packageSize,
      strength:
        o.medStrength && o.medStrengthUnit
          ? `${o.medStrength} ${o.medStrengthUnit}`.toUpperCase()
          : "",
      dosageForm: dosageForm,

      ltcAwpBulk: getCurrentPrice("WHNPKG"),
      ltcAwpItem: getCurrentPrice("WHN"),
    };
    onAdd(product);
  };

  return (
    <Space direction={"vertical"}>
      <Search
        enterButton
        placeholder={t("enterNdcLabel")}
        onSearch={onSearch}
        defaultValue={packageId}
      />
      {fdbPackagedDrug && (
        <>
          <p>
            <b>{t("packageIdLabel")}:</b> {fdbPackagedDrug.ndcFormatted}
          </p>
          <p>
            <b>{t("descriptionLabel")}:</b> {fdbPackagedDrug.packagedDrugDesc}
          </p>
          <p>
            <b>{t("labelerLabel")}:</b> {fdbPackagedDrug.labelerName}
          </p>
          <p>
            <b>{t("substitutionIdLabel")}:</b>{" "}
            {fdbPackagedDrug.dispensableGenericID}
          </p>
          <p>
            <b>{t("packageLabel")}:</b> {fdbPackagedDrug.packageSize}{" "}
            {fdbPackagedDrug.packageDesc}
          </p>
          <Button onClick={convert} type={"primary"}>
            {isNew ? t("addProductLabel") : t("updateProductLabel")}
          </Button>
        </>
      )}
      {error && <p>{error}</p>}
    </Space>
  );
};

export default FdbLookup;
